<template>
  <div class="register">
    <div class="auth-container">
      <form @submit.prevent="registerController()">
        <h2 class="title">Registrarse a Talki Teachers</h2>

        <div id="errorLogin">
          <p>Algunos campos son incorrectos</p>
        </div>

        <div class="form-group">
          <label for="email">
            <i class="fa-solid fa-user"></i>
          </label>
          <input type="text" id="name" placeholder="Nombre(s)" autocomplete="off" v-model="userData.name" />
        </div>

        <div class="form-group">
          <label for="email">
            <i class="fa-solid fa-at"></i>
          </label>
          <input type="text" id="email" placeholder="Email" autocomplete="off" v-model="userData.email" />
        </div>

        <div class="form-group">
          <label for="password">
            <i class="fas fa-lock"></i>
          </label>
          <input type="password" id="password" placeholder="Contraseña" v-model="userData.password" />
        </div>

        <button class="button" type="submit">Registrarse</button>

        <div class="bottom-login">
          <p class="link" @click="goToRoute('')">
            ¿Tienes cuenta? Inicia sesión aquí
          </p>
        </div>
      </form>
    </div>

    <dialog id="favDialog">
      <p>Registró exitoso</p>
      <button class="button" @click="goToRoute('')">Ir a login</button>
    </dialog>

  </div>
</template>
      
<script>
import router from "@/router";

export default {
  name: "RegisterView",
  data() {
    return {
      favDialog: null,
      userData: {
        name: "",
        email: "",
        password: "",
        roles: ["ROLE_TEACHER"],
      },
    };
  },
  mounted() {
    this.favDialog = document.getElementById("favDialog");
    this.errorLogin = document.getElementById("errorLogin");
  },
  methods: {
    async registerController() {
      if (this.userData.name == "" || this.userData.email == "" || this.userData.password == "") {
        this.showError();
        return;
      }
      try {
        const response = await this.$axios.post(
          "/users/auth/sign-up",
          this.userData
        );

        console.log("Respuesta del servidor:", response.data);

        if (response.data.roles[0] == "ROLE_STUDENT") {
          this.showError();
        } else {
          this.favDialog.showModal();
        }
      } catch (error) {
        this.showError();
      }
    },
    goToRoute(route) {
      router.push("/" + route);
    },
    showError() {
      this.errorLogin.style.display = 'block';
      setTimeout(() => {
        this.errorLogin.style.display = 'none'
      }, 3000);
    },
  },
};
</script>
    
<style scoped>
.register {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: var(--main-color);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.auth-container {
  overflow: hidden;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.side-2 {
  height: 100%;
  background-color: var(--main-color);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 30px;
  padding: 10px;
}

.side-2 p {
  color: white;
  margin: 0;
}

.title-side-2 {
  font-size: 30px;
  color: white;
  margin: 0;
}

.title {
  font-size: 24px;
  color: var(--main-color);
  margin-bottom: 0px;
  text-align: start;
}

form {
  background-color: white;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  width: 350px;
  padding: 40px 50px;
}

.form-group {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f4f8f7;
  padding: 10px 0;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

.form-group label {
  margin-left: 10px;
  margin-right: 10px;
}

i {
  color: var(--another-grey);
}

.form-group input {
  background-color: transparent;
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
}

.button {
  width: 200px;
  background-color: var(--main-color);
  color: var(--white);
  border: none;
  padding: 15px 20px;
  cursor: pointer;
  font-size: 15px;
  letter-spacing: 1.2px;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  transition: all ease-out 0.2s;
  -webkit-transition: all ease-out 0.2s;
  -moz-transition: all ease-out 0.2s;
  -ms-transition: all ease-out 0.2s;
  -o-transition: all ease-out 0.2s;
  text-transform: uppercase;
}

.button:hover {
  transform: scale(1.05);
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -ms-transform: scale(1.05);
  -o-transform: scale(1.05);
}

.bottom-login {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
}

.link {
  margin: 5px 0 0 0;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  color: var(--main-color);
  transition: all ease-out 0.2s;
  -webkit-transition: all ease-out 0.2s;
  -moz-transition: all ease-out 0.2s;
  -ms-transition: all ease-out 0.2s;
  -o-transition: all ease-out 0.2s;
}

.link:hover {
  transform: scale(1.05);
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -ms-transform: scale(1.05);
  -o-transform: scale(1.05);
}

.forgot {
  color: var(--darker-main-color);
}

#errorLogin {
  display: none;
  width: 100%;
  background-color: #ffe7e7;
  border: 1px solid red;
  color: red;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  text-align: center;
}

dialog {
  border: none !important;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  padding: 2rem;
}
</style>